import { Suspense } from 'react';
import ProLayout from '@ant-design/pro-layout';
import CommonHead from '@/components/CommonHead'

export default function BasicLayout({ children, location }) {
  const blackList = ['/materialDetail', '/courseDetail', '/coursePlay']
  const hasBottom = !blackList.includes(location.pathname)
  return (
    <ProLayout pure>
      <Suspense fallback={<div></div>}>
        <CommonHead hasBottom={hasBottom} link={location.pathname}></CommonHead>
        <div style={{ minHeight: 'calc(100vh - 88px)', paddingBottom: '20px', background: '#F5F5FA' }}>
          {children}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#aaaaaa',
              marginTop: 18,
            }}
          >
            <span>Copyright©2021-2022 Sunwoda. All Rights Reserved</span>
            <span><a href="https://www.sunwoda.com" target="_blank" style={{color: '#aaaaaa'}}>欣旺达</a> 版权所有</span>
          </div>
        </div>
      </Suspense>
    </ProLayout>
  );
}
